<template>
  <Link
    :href="href"
    :class="classes"
  >
    <slot />
  </Link>
</template>

<script>
import {Link} from "@inertiajs/vue3";

export default {
    components: {
        Link
    },
  props: ['href', 'active'],

  computed: {
    classes() {
      return this.active
        ? 'group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-900 rounded-md bg-gray-100 outline-none text-gray-900 transition ease-in-out duration-150'
        : 'group flex items-center px-2 py-2 text-sm leading-5 font-medium text-gray-600 rounded-md hover:text-gray-900 hover:underline hover:bg-gray-100 transition ease-in-out duration-150';
    },
  },
};
</script>
